// extracted by mini-css-extract-plugin
export default {"Home":"Home_Home__uPel5","Categories":"Home_Categories__lt3f6","DecorativeImg":"Home_DecorativeImg__hwRyX","Link":"Home_Link__cx8lS"};